export const linkTypeMap = {
  WEB_LINK: "Web link",
  DEEP_LINK: "Deep link",
  QUIZ_LINK: "Quiz link",
  DO_NOT_REDIRECT: "Don't Redirect",
};
